import lifecycle from 'recompose/lifecycle';

const onUnload = lifecycle({
  componentDidMount() {
    if (this.props.onUnload) {
      window.addEventListener('unload', this.props.onUnload);
    }
  },
  componentWillUnmount() {
    if (this.props.onUnload) {
      this.props.onUnload();
      window.removeEventListener('unload', this.props.onUnload);
    }
  },
});

export default onUnload;



// WEBPACK FOOTER //
// ./src/app/hoc/OnUnload.js